<!-- Barra de Comunicados - Fija Horizontal -->
<div class="comunicados-barra-fija" *ngIf="comunicadosWidget.visible">
  <!-- Encabezado -->
  <div class="barra-header"
       (click)="toggleComunicados()"
       [class.urgente]="hayUrgentes"
       [class.expandido]="comunicadosWidget.expandido">

    <div class="barra-info">
      <div class="barra-texto">
        <span class="titulo">Comunicados Oficiales</span>
        <span class="subtitulo" *ngIf="contadorComunicados > 0">
          {{ contadorComunicados }} comunicado{{ contadorComunicados !== 1 ? 's' : '' }}
          <span *ngIf="hayUrgentes" class="urgente-tag">• URGENTE</span>
        </span>
      </div>
    </div>

    <div class="barra-controles">
      <button class="btn-toggle" [class.expandido]="comunicadosWidget.expandido">
        <span *ngIf="!comunicadosWidget.expandido">▲ Expandir</span>
        <span *ngIf="comunicadosWidget.expandido">▼ Contraer</span>
      </button>
    </div>
  </div>

  <!-- Contenido expandible -->
  <div class="barra-contenido" *ngIf="comunicadosWidget.expandido">

    <!-- Loading -->
    <div class="loading-comunicados" *ngIf="comunicadosWidget.cargando || cargandoDespachos">
      <div class="spinner-small"></div>
      <span>Cargando información...</span>
    </div>

    <div class="comunicados-horizontal" *ngIf="!comunicadosWidget.cargando && !cargandoDespachos">
      <div class="comunicados-container">
        <!-- Izquierda: comunicado -->
        <div class="comunicado-seccion">
          <div class="comunicado-card"
               *ngFor="let comunicado of getComunicadosVisibles(); trackBy: trackByComunicado"
               [ngClass]="getClaseTipoComunicado(comunicado.tipo)">

            <div class="card-header">
              <div class="tipo-badge" [ngClass]="getClaseTipoComunicado(comunicado.tipo)">
                {{ comunicado.tipo.toUpperCase() || 'INFO' }}
              </div>
              <div class="fecha">{{ formatearFechaComunicado(comunicado) }}</div>
            </div>

            <h5 class="card-titulo">{{ comunicado.titulo }}</h5>

            <p class="card-contenido">
              {{ truncarContenido(comunicado.contenido, 150) }}
            </p>

            <div class="card-footer" *ngIf="comunicado.publicado_por">
              <span class="autor">{{ comunicado.publicado_por }}</span>
            </div>
          </div>
        </div>

        <!-- Derecha: despachos activos -->
        <div class="despachos-seccion">
          <div class="despacho-card"
               *ngIf="getDespachoVisible() as despacho"
               [ngClass]="[getClaseTipoDespacho(despacho.categoria), getClaseEstadoDespacho(despacho.estado)]">

            <div class="despacho-header">
              <div class="codigo-despacho">{{ despacho.codigo }}</div>
              <div class="tiempo-transcurrido">{{ getTiempoTranscurrido(despacho.hora_despacho) }}</div>
            </div>

            <div class="despacho-info">
              <div class="tipo-prioridad">
                <!-- AHORA muestra la CATEGORÍA -->
                <span class="tipo-badge" [ngClass]="getClaseTipoDespacho(despacho.categoria)">
                  {{ despacho.categoria.toUpperCase() }}
                </span>
              </div>
            </div>

            <div class="direccion-despacho">
              <span class="direccion-label">📍</span>
              <span class="direccion-texto">{{ despacho.direccion }}, {{ despacho.comuna }}</span>
              <!-- Estado del geocoding -->
              <div class="geocoding-status" 
                   [class.geocoding-ok]="despacho.tieneGeocodificacion"
                   [class.geocoding-pending]="!despacho.tieneGeocodificacion">
                <small>{{ getEstadoGeocodificacion() }}</small>
              </div>
            </div>

            <div class="carros-asignados">
              <span class="carros-label">🚒</span>
              <div class="carros-lista">
                <span class="carro-item" *ngFor="let carro of despacho.carros_asignados">
                  {{ carro }}
                </span>
                <!-- Placeholder cuando no hay carros asignados -->
                <span class="carro-placeholder" *ngIf="despacho.carros_asignados.length === 0">
                  En asignación...
                </span>
              </div>
            </div>

            <!-- Mapa mejorado -->
            <div class="mapa-simulado mapa-container" 
                 [class.mapa-aproximado]="!despacho.tieneGeocodificacion"
                 [class.mapa-exacto]="despacho.tieneGeocodificacion">
              
              <!-- Indicador de ubicación aproximada -->
              <div class="ubicacion-warning" 
                   *ngIf="!despacho.tieneGeocodificacion"
                   title="Ubicación aproximada - Geocodificación en proceso">
                ⚠️ Aproximada
              </div>

              <!-- Botón para recentrar/actualizar ubicación -->
              <div class="mapa-controles" *ngIf="!despacho.tieneGeocodificacion">
                <button class="btn-actualizar-ubicacion" 
                        (click)="solicitarGeocodificacion(despacho.id)"
                        title="Actualizar ubicación">
                  🔄
                </button>
              </div>

              <app-map-view
                  [center]="despacho.coordenadas"
                  [zoom]="despacho.tieneGeocodificacion ? 16 : 12"
                  [marker]="true"
                  [categoria]="despacho.categoria"
                  [codigo]="despacho.codigo">
              </app-map-view>
            </div>
          </div>

          <!-- Sin despachos -->
          <div class="sin-despachos" *ngIf="!getDespachoVisible()">
            <div class="sin-despachos-icon">📻</div>
            <span class="sin-despachos-texto">Sin despachos activos</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Sin comunicados -->
    <div class="sin-comunicados-horizontal" *ngIf="!comunicadosWidget.cargando && comunicados.length === 0">
      <div class="sin-comunicados-icon">📭</div>
      <p>No hay comunicados disponibles en este momento</p>
    </div>
  </div>
</div>